import makeFullUrl from "./cloudinary";

/**
 * Given a mainImage object and an array of zero-or-more "images" objects,
 * returns exactly 4 slots [ imgObj, imgObj, imgObj, imgObj ], cycling or
 * falling back to mainImage if necessary.
 *
 * Each image object is assumed to have at least:
 *   { filePath: string, fileType: string }
 *
 * @param {{ filePath: string, fileType: string }} mainImage
 * @param {Array<{ filePath: string, fileType: string }>} images
 * @returns {Array<{ filePath: string, fileType: string }>}
 */
export function getDisplayImages(mainImage, images) {
  // If no “images” were provided (length 0 or not an array), treat source = [mainImage].
  const source =
    Array.isArray(images) && images.length > 0 ? images : [mainImage];

  const result = [];
  for (let i = 0; i < 4; i++) {
    result.push(source[i % source.length]);
  }
  return result;
}

/**
 * Takes either a single image‐metadata object or an array of them,
 * and returns an array of four full URLs (using makeFullUrl).
 *
 * @param {{ filePath: string, fileType: string }} mainImage
 * @param {Array<{ filePath: string, fileType: string }>} images
 * @returns {Array<string>}    // exactly 4 strings
 */
export function getDisplayImageUrls(mainImage, images) {
  // 1) Get exactly four image‐info objects
  const fourImageObjs = getDisplayImages(mainImage, images);

  // 2) Turn each into a Cloudinary URL
  return fourImageObjs.map((imgObj) => {
    if (!imgObj || !imgObj.filePath || !imgObj.fileType) {
      return ""; // or some placeholder URL
    }
    return makeFullUrl(imgObj.filePath, imgObj.fileType);
  });
}
